<template>
  <zg-kh-cft-scan-dialog
    :visible="visible"
    :qrcode-str="cftScan.qrcodeStr"
    :qrcode-status="cftScan.qrcodeStatus"
    :append-to-body="true"
    @qrRefresh="cftScanQrRefresh"
    @closeHandler="cftScanCloseHandler"
  ></zg-kh-cft-scan-dialog>
</template>

<script>
import { CftScanDialog } from 'zgkaihu'
export default {
  name: 'RefundTenpayQrcode',
  components: { [CftScanDialog.name]: CftScanDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    qrcodeInfo: {
      type: Object,
      default: () => ({
        expireTime: 0,
        qrCode: ''
      })
    },
    reqInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      cftScan: {
        qrcodeStr: '',
        /**0:初始化加载中 1:正常显示 -1:接口请求失败 -2:二维码失效 -3:扫描二维码超时 */
        qrcodeStatus: { code: 0 },
        timer: 0
      }
    }
  },
  watch: {
    qrcodeInfo: {
      handler: 'handleQrcodeInfoChange',
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleQrcodeInfoChange() {
      if (this.qrcodeInfo.qrCode) {
        this.cftScanInit()
      }
    },
    cftScanInit() {
      this.cftScan.qrcodeStr = this.qrcodeInfo.qrCode
      this.cftScan.qrcodeStatus = { code: 1 }
      this.cftScanLoop()
    },
    async cftScanLoop() {
      //校验二维码是否失效
      if (Date.now() > this.qrcodeInfo.expireTime) {
        this.cftScan.qrcodeStatus = { code: -2 } //二维码失效
        return
      }
      try {
        const { success, data } = await this.$get(
          'refund.findSellerOrderRefundDetail',
          {
            findSellerOrderRefundDetailParam: {
              id: this.reqInfo.id,
              pageNum: 1,
              pageSize: 10
            }
          },
          { notNeedLoading: true }
        )
        if (success && data) {
          if (
            data[0] &&
            data[0].success &&
            data[0].items &&
            data[0].items[0] &&
            data[0].items[0].refundStatus !== 2
          ) {
            this.$emit('success')
          } else {
            this.cftScan.timer = setTimeout(this.cftScanLoop, 2000)
          }
        } else {
          this.cftScan.qrcodeStatus = { code: -1 }
        }
      } catch (err) {
        console.log(err)
        this.cftScan.qrcodeStatus = { code: -1 }
      }
    },
    async cftScanQrRefresh() {
      try {
        const { success, data } = await this.$post(
          'refund.sellerConfirmOrderRefund',
          {
            sellerConfirmOrderRefundPara: this.reqInfo.sellerConfirmOrderRefundPara
          },
          { notNeedLoading: true }
        )
        if (success && data[0] && data[0].success) {
          if (data[0].qrCode) {
            this.qrcodeInfo.qrCode = data[0].qrCode
            this.qrcodeInfo.expireTime = data[0].expireTime
          } else {
            this.cftScan.qrcodeStatus = { code: -2 }
          }
        } else {
          this.cftScan.qrcodeStatus = { code: -1 }
        }
      } catch (err) {
        console.log(err)
        this.cftScan.qrcodeStatus = { code: -1 }
      }
    },
    cftScanCloseHandler() {
      this.cftScan.qrcodeStr = ''
      this.cftScan.qrcodeStatus = { code: 0 }
      this.qrcodeInfo.expireTime = 0
      this.qrcodeInfo.qrCode = ''
      this.cftScanLoopClear()
      this.$emit('update:visible', false)
      this.$emit('closeHandler')
    },
    cftScanLoopClear() {
      this.cftScan.timer && clearTimeout(this.cftScan.timer)
    }
  }
}
</script>
